import React from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AppInfo.css';

const AppInfo = () => {
  const content = (
    <div className="AppInfo">
      <p>Welcome to BPS Review</p>
      <p>You are logged out</p>
    </div>
  );
  return content;
};

const mapState = state => ({
})

const mapDispatch = dispatch => ({
})

export default connect(mapState, mapDispatch)(AppInfo);
